import React from 'react';
import { T } from 'shared/helper/translate';
import DigitalTranslationsUniques from './DigitalTranslationsUniques';
var DigitalTranslationsOverview = function DigitalTranslationsOverview() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "digital-translations-intro-heading"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-overview"
  }), /*#__PURE__*/React.createElement(DigitalTranslationsUniques, null));
};
export default DigitalTranslationsOverview;